import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import a32 from "../../../../assets/edgemarketing/a32.png"
import a3322 from "../../../../assets/edgemarketing/a3322.png"

import '../edgemarketing.css'


function Moreintro() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#101010",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       {isSmallScreen ? (
          <Image src={a3322} alt='a33' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={a32} alt='a3' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
    </Container>
    
     
    
  )
}

export default Moreintro
